module.exports = __webpack_public_path__ + "media/FaktSoftPro-Normal_914638.woff2";